define('taoQtiItem/qtiXmlRenderer/renderers/interactions/GraphicGapMatchInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/graphicGapMatchInteraction'], function(tpl){
    return {
        qtiClass : 'graphicGapMatchInteraction',
        template : tpl
    };
});
